export default "__VITE_ASSET__BWOgRlxb__"